import { ChevronLeft, ChevronRight } from "lucide-react";

export interface PaginationProps {
  canGoBack: boolean;
  canGoForward: boolean;
  onBack: () => void;
  onForward: () => void;
  isLoading: boolean;
}

export function Pagination({
  canGoBack,
  canGoForward,
  onBack,
  onForward,
  isLoading,
}: PaginationProps) {
  return (
    <nav
      className="mt-4 flex items-center justify-end gap-2"
      aria-label="Пагинация"
    >
      <button
        className="inline-flex h-10 items-center gap-2 rounded-md border bg-card px-3 text-sm font-medium transition-colors hover:border-primary/40 hover:bg-accent disabled:cursor-not-allowed disabled:opacity-50"
        type="button"
        aria-label="Предыдущая страница"
        disabled={!canGoBack || isLoading}
        onClick={onBack}
      >
        <ChevronLeft className="h-4 w-4" />
        Назад
      </button>
      <button
        className="inline-flex h-10 items-center gap-2 rounded-md border bg-card px-3 text-sm font-medium transition-colors hover:border-primary/40 hover:bg-accent disabled:cursor-not-allowed disabled:opacity-50"
        type="button"
        aria-label="Следующая страница"
        disabled={!canGoForward || isLoading}
        onClick={onForward}
      >
        Вперёд
        <ChevronRight className="h-4 w-4" />
      </button>
    </nav>
  );
}
